import { Injectable } from '@angular/core';
declare let gtag: Function;

/**
 *  Import GoogleAnalyticsEventService
 *  this.ga.emitEvent('Favorit Page', 'Item Click', '');
 *  Parameters
 *  1 -> Category Name
 *  2 -> Action like Click , Added to Cart , Payment navigation
 *  3 -> Data like url or Item Id
 *  4 -> Additional Value (optional)
 */

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsEventsService {

    public emitEvent(
        eventName: string,
        eventCategory: string,
        eventValue: string,
    ) {
        gtag('event', eventName, {
            [eventCategory]: eventValue,
        });
    }
}
